import { useCallback, useRef } from 'react';

// A solution to fix async validation running everytime other fields change
export const useAsyncValidationMemo = () => {
	const lastArg = useRef<string | undefined>(undefined);
	const lastResult = useRef<string | undefined>(undefined);

	const memoize = useCallback((fn: (value?: string) => Promise<string | undefined>) => {
		return async (arg?: string) => {
			if (arg !== lastArg.current) {
				lastArg.current = arg;
				lastResult.current = await fn(arg);
			}
			return lastResult.current;
		};
	}, []);

	return { memoize };
};
